import { useSelector } from 'react-redux';

 
import { getAssetToAddress } from '../../redux/selectors';
import { AssetToAddress } from '../../redux/slices';

export const useAssetToAddress = (): AssetToAddress => {
  const assetToAddress = useSelector(getAssetToAddress);

  return assetToAddress;
};
